import React from "react";
import { Link } from "react-router-dom";
import AuthLayout from "@/components/auth/AuthLayout";

const TokenExpired: React.FC = () => {
    return (
        <AuthLayout 
            title="Session Expired" 
            subtitle="The access link you used is no longer valid or has expired for security reasons. Please login using your credentials or contact support."
        >
            <div className="tw-space-y-4 tw-relative tw-z-20 tw-mt-8 tw-max-w-md">
                {/* Visual indicator (optional, using standard AuthLayout logic) */}
                
                <div className="tw-space-y-3">
                    <Link
                        to="/customer-login"
                        className="tw-w-full tw-flex tw-justify-center tw-p-4 tw-border tw-border-transparent tw-rounded-md tw-shadow-md tw-text-sm tw-font-medium tw-text-black tw-bg-[#00C5FB] hover:tw-bg-white focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 tw-transition-colors tw-duration-700"
                        style={{ fontFamily: "'Outfit', sans-serif" }}
                    >
                        Login with Credentials
                    </Link>
                    
                    <a
                        href="mailto:support@protega.ai"
                        className="tw-w-full tw-flex tw-justify-center tw-p-4 tw-bg-transparent tw-text-white tw-border tw-border-gray-700 tw-font-medium tw-rounded-md hover:tw-bg-white/10 tw-transition-all tw-duration-300 tw-text-sm"
                        style={{ fontFamily: "'Outfit', sans-serif" }}
                    >
                        Contact Support
                    </a>
                </div>

                <div className="tw-pt-10">
                    <p className="tw-text-xs tw-text-gray-500 tw-leading-relaxed" style={{ fontFamily: "'Outfit', sans-serif" }}>
                        Need immediate assistance? Contact our team at <span className="tw-text-[#00C5FB] tw-font-medium">support@protega.ai</span> or call <span className="tw-text-[#00C5FB] tw-font-medium">022 6962 0766</span>. 
                        We are available to help you initiate your return.
                    </p>
                </div>
            </div>
        </AuthLayout>
    );
};

export default TokenExpired;
